// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-ia-tuwen-image-list{overflow:auto;flex-wrap:wrap}.plv-ia-tuwen-image-list img{width:200px;height:200px;margin-right:24px;margin-bottom:24px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
